import { createRouter, createWebHistory } from 'vue-router';
import store from '../store/index'; // Import your Vuex store





import HomeM from '../views/Public/Home.vue';

import Alumni from '../views/Public/Alumni.vue';
import Profile from '../views/Public/Profile.vue';
import Messages from '../views/Public/Messages.vue';
import Events from '../views/Public/Events.vue';
import Settings from '../views/Public/Settings.vue';




import AdminLogin from '../views/Admin/Login.vue';
import Login from '../views/Public/Login.vue';

import AboutI from '../views/Public/AboutM.vue';
import ContactI from '../views/Public/Contact.vue';
import KAA from '../views/Public/KAA.vue'
import AlumniList from '../views/Admin/AlumniList.vue';
// import AlumniRegister from '../views/Public/CreateAccount.vue'
import Register from '../views/Public/Register.vue';
import CreateAccount from '../views/Public/CreateAccount.vue';

const routes = [
    { path: '/', component: Register },

    { path: '/register', component: CreateAccount },
    { path: '/create_account', component: CreateAccount },
    { path: '/login', component: Login },
    { path: '/alumni_register', component: HomeM },
    { path: '/kaa', component: KAA },
    {path: '/alumni', 
      component: Alumni,
      meta: {requiresAuth:true}},

    { path: '/profile', component: Profile, meta: {requiresAuth:true}},
    { path: '/messages', component: Messages, meta: {requiresAuth:true}},
    { path: '/events', component: Events, meta: {requiresAuth:true}},
    { path: '/settings', component: Settings, meta: {requiresAuth:true}},

    { path: '/contact', component: ContactI },
    

    {   path: '/admin/login', component: AdminLogin},
    {  
         path: '/admin/alumni',
         component: AlumniList,
         meta: { requiresAuth: true }, // Protect this route
    },


];

const router = createRouter({
    history: createWebHistory('/'), 
    routes,
});


// Global navigation guard
router.beforeEach((to, from, next) => {
    const isAuthenticated = store.getters.isAuthenticated; // Check Vuex getter
  
    if (to.meta.requiresAuth && !isAuthenticated) {
      // If the route requires authentication and the user is not authenticated
      next('/admin/login'); // Redirect to login page
    } else {
      next(); // Proceed to the route
    }
  });






export default router;
